/**
 * PUT a S3 (u otra URL) con progreso 0–100.
 * fetch() no expone upload progress; hace falta XHR.
 */
export function uploadWithProgress(url, { body, contentType, onProgress }) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url);
    if (contentType) xhr.setRequestHeader("Content-Type", contentType);
    xhr.upload.onprogress = (e) => {
      if (!e.lengthComputable || typeof onProgress !== "function") return;
      onProgress(Math.min(100, Math.round((e.loaded / e.total) * 100)));
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve(xhr);
      else reject(new Error(`Falló la subida (${xhr.status})`));
    };
    xhr.onerror = () => reject(new Error("Error de red al subir"));
    xhr.onabort = () => reject(new Error("Subida cancelada"));
    xhr.send(body);
  });
}
